var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"technology"},[_c('ul',_vm._l((_vm.data),function(item){return _c('li',[_c('img',{attrs:{"src":require(`@/assets/images/${item.img}.png`),"alt":""}}),_c('h3',[_vm._v(_vm._s(item.title))]),_c('p',{domProps:{"innerHTML":_vm._s(item.content)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }